/**
 * Add a help button to the top-right
 * <helpButton helpId="1001" />
 */
angular.module('qkr').directive('helpButton', ['helpService', 'gettextCatalog', function(helpService, gettextCatalog) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<span popover-extraclass="help" popover-placement="bottom" popover-html-unsafe="{{helpMsg}}" popover-append-to-body="true" popover-zindex="{{elemzindex}}" class="pull-right help-button">&nbsp;{{getLabel()}}&nbsp;<i id="{{helpId}}" class="help-symbol fa"></i></span>',
            link(scope, elem, attrs) {
                scope.elemzindex = 1;
                // Var t= $uibModalStack.getSize(); getSize removed from ui-boostrap 0.12.1
                // Scope.elemzindex = t!= 0?1040+(t*10)+1:1;

                scope.elemzindex = 1;

                if (typeof (attrs.helpid) !== 'undefined') {
                    scope.helpId = attrs.helpid;
                    if (helpService.helpLoaded) {
                        scope.helpMsg = helpService.getHelpMsg(attrs.helpid);
                    } else {
                        scope.$on('HelpLoaded', (as) => {
                            scope.helpMsg = helpService.getHelpMsg(scope.helpId);
                        });
                    }
                } else {
                    scope.helpMsg = '';
                }

                scope.getLabel = function() {
                    return gettextCatalog.getString('Help');
                };
            }
        };
}])
    ;




// WEBPACK FOOTER //
// ./src/directives/help_button.js